export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 6_24.9c845a68.jpg";